module.exports = __webpack_public_path__ + "assets/img/one-2.c964a9eb.svg";